import { apiClient, buildWebSocketUrl } from './client'
import type {
  BoxCloseResult,
  BoxScanView,
  ScanAcceptResult,
  ScanDuplicateEvent,
} from '@/types/task-scan'

export const taskScanApi = {
  getBox: (taskUuid: string, boxNum: number) =>
    apiClient.get<{ item: BoxScanView }>(
      `/api/tasks/${encodeURIComponent(taskUuid)}/scan/boxes/${boxNum}`,
    ),

  openBox: (taskUuid: string, boxNum: number, workerName: string, agentId?: string) =>
    apiClient.post<{ item: BoxScanView }>(
      `/api/tasks/${encodeURIComponent(taskUuid)}/scan/boxes/${boxNum}/open`,
      { worker_name: workerName, ...(agentId ? { print_agent_id: agentId } : {}) },
    ),

  scan: (taskUuid: string, boxNum: number, code: string, workerName: string, agentId?: string) =>
    apiClient.post<{ item: ScanAcceptResult }>(
      `/api/tasks/${encodeURIComponent(taskUuid)}/scan/boxes/${boxNum}/scan`,
      { code, worker_name: workerName, ...(agentId ? { print_agent_id: agentId } : {}) },
    ),

  closeBox: (taskUuid: string, boxNum: number) =>
    apiClient.post<{ item: BoxCloseResult }>(
      `/api/tasks/${encodeURIComponent(taskUuid)}/scan/boxes/${boxNum}/close`,
      {},
    ),

  reopenBox: (taskUuid: string, boxNum: number, workerName: string, agentId?: string) =>
    apiClient.post<{ item: BoxScanView }>(
      `/api/tasks/${encodeURIComponent(taskUuid)}/scan/boxes/${boxNum}/reopen`,
      { worker_name: workerName, ...(agentId ? { print_agent_id: agentId } : {}) },
    ),

  boxWebSocketUrl: (taskUuid: string, boxNum: number) =>
    buildWebSocketUrl(`/api/tasks/${encodeURIComponent(taskUuid)}/scan/boxes/${boxNum}/ws`),

  listDuplicates: (taskUuid: string, params?: { limit?: number; offset?: number }) =>
    apiClient.get<{ data: ScanDuplicateEvent[]; total: number; limit: number; offset: number }>(
      `/api/tasks/${encodeURIComponent(taskUuid)}/scan/duplicates`,
      { params },
    ),
}
